var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.844,
    cy: 18.8716,
    r: 18,
    fill: "#F2F5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8354 14.4127C9.67989 14.4127 8.74316 15.3494 8.74316 16.5049V22.1506C8.74316 23.2596 8.74316 23.8141 8.83811 24.2747C9.20987 26.0781 10.6191 27.4873 12.4225 27.859C12.883 27.954 13.4375 27.954 14.5466 27.954H23.2517C24.3607 27.954 24.9152 27.954 25.3758 27.859C27.1792 27.4873 28.5884 26.0781 28.9601 24.2747C29.0551 23.8141 29.0551 23.2596 29.0551 22.1506V16.5049C29.0551 15.3494 28.1184 14.4127 26.9628 14.4127C26.1704 14.4127 25.4459 13.9649 25.0915 13.2561L24.1652 11.4035C23.7041 10.4814 22.7617 9.89893 21.7307 9.89893H16.0675C15.0366 9.89893 14.0941 10.4814 13.6331 11.4035L12.7068 13.2561C12.3524 13.9649 11.6279 14.4127 10.8354 14.4127ZM20.3395 20.0545C20.3395 20.85 19.6946 21.4949 18.8991 21.4949C18.1036 21.4949 17.4587 20.85 17.4587 20.0545C17.4587 19.259 18.1036 18.6141 18.8991 18.6141C19.6946 18.6141 20.3395 19.259 20.3395 20.0545ZM23.4129 20.0545C23.4129 22.5474 21.392 24.5683 18.8991 24.5683C16.4062 24.5683 14.3853 22.5474 14.3853 20.0545C14.3853 17.5616 16.4062 15.5407 18.8991 15.5407C21.392 15.5407 23.4129 17.5616 23.4129 20.0545Z",
    fill: "#534E54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.9134108c70a0685561ce601411fa3620.svg";
export { ForwardRef as ReactComponent };